// extracted by mini-css-extract-plugin
export default {"content":"wntml","table":"UpynX","hint":"hH0b2"};